module.exports = __webpack_public_path__ + "img/hy.3367445d.svg";